import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Logo } from "@/components/comiq/Logo";
import { Eyebrow } from "@/components/comiq/Eyebrow";
import { COLORS } from "@/comiq/tokens";
import { useAuth } from "@/admin/AuthContext";
import api from "@/admin/api";

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { identifier, password });
      setUser(r.data);
      const dest = location.state?.from?.pathname || "/admin";
      navigate(dest, { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Email/username atau password salah");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-5" style={{ background: COLORS.paper }}>
      <div className="w-full max-w-sm rounded-comiq-lg border bg-comiq-surface-alt p-8" style={{ borderColor: COLORS.line }}>
        <div className="flex justify-center"><Logo /></div>
        <Eyebrow className="mt-6 block text-center">Research Admin</Eyebrow>
        <h1 className="font-serif-editorial mt-2 text-center text-3xl" style={{ color: COLORS.ink }}>Masuk ke dashboard</h1>
        <p className="mt-2 text-center text-sm" style={{ color: COLORS.textSoft }}>
          Khusus tim riset ComIQ. Masuk dengan email atau username dan password.
        </p>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <div>
            <label className="block text-xs font-semibold" style={{ color: COLORS.ink }}>Email atau username</label>
            <input
              className="mt-1 w-full rounded-comiq-sm border bg-white px-3 py-2 text-sm outline-none"
              style={{ borderColor: COLORS.line, color: COLORS.ink }}
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              autoComplete="username"
              required
              data-testid="login-identifier-input"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold" style={{ color: COLORS.ink }}>Password</label>
            <input
              type="password"
              className="mt-1 w-full rounded-comiq-sm border bg-white px-3 py-2 text-sm outline-none"
              style={{ borderColor: COLORS.line, color: COLORS.ink }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="rounded-comiq-sm px-3 py-2 text-xs font-medium" style={{ background: "#FEE4E2", color: "#B42318" }}>
              {error}
            </p>
          )}
          <button type="submit" disabled={busy} className="btn-comiq btn-accent w-full justify-center" data-testid="login-submit-btn">
            {busy ? "Memproses…" : "Masuk"}
          </button>
        </form>

        <button
          type="button"
          onClick={() => setShowForgot((v) => !v)}
          className="mt-4 block w-full text-center text-xs font-semibold underline"
          style={{ color: COLORS.textSoft }}
          data-testid="forgot-password-link"
        >
          Lupa password?
        </button>
        {showForgot && (
          <p data-testid="forgot-password-note" className="mt-2 rounded-comiq-sm px-3 py-2 text-xs" style={{ background: COLORS.paper, color: COLORS.textSoft }}>
            Reset password dikelola oleh Super Admin. Hubungi Super Admin ComIQ Anda untuk mengatur ulang password akun ini.
          </p>
        )}
      </div>
    </div>
  );
}
